import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

const initialForm = {
  name: '',
  email: '',
  password: '',
  address: '',
  phone: ''
};

export default function RegisterPage() {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (message.text) {
      setMessage({ type: '', text: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!form.name || !form.email || !form.password || !form.address || !form.phone) {
      setMessage({
        type: 'warning',
        text: 'Please fill in all fields.'
      });
      return;
    }

    if (form.password.length < 6) {
      setMessage({
        type: 'warning',
        text: 'Password must be at least 6 characters.'
      });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        password: form.password,
        address: form.address.trim(),
        phone: form.phone.trim()
      };

      console.log('Sending payload:', payload);

      const response = await api.post('/auth/register', payload);
      const data = response.data;

      if (!data || response.status >= 400) {
        throw new Error(data?.message || 'Registration failed');
      }

      setMessage({
        type: 'success',
        text: typeof data === 'object' 
          ? (data.message || 'Registration successful. You can now sign in.') 
          : (data || 'Registration successful. You can now sign in.')
      });
      setForm(initialForm);
    } catch (error) {
      console.error('Registration error:', error);
      
      let errorMessage = 'Registration failed.';
      
      if (error.message.includes('Failed to fetch')) {
        errorMessage = 'Cannot connect to backend. Make sure the server is running on http://localhost:5000';
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setMessage({
        type: 'danger',
        text: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="hero-banner">
        <div className="container">
          <h1 className="hero-title">
            Create <em className="gold-text">Account</em>
          </h1>
          <p className="text-white-50 mb-0">Join Pandian Store and enjoy a smooth shopping experience.</p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-xl-5">
            <div className="form-card">
              <h3 className="card-title">
                <i className="fas fa-user-plus location-icon" /> Register
              </h3>

              <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                  <label className="input-label" htmlFor="name">Full Name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    className="text-input"
                    placeholder="Enter your full name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="input-label" htmlFor="email">Email Address</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="text-input"
                    placeholder="Enter your email"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="input-label" htmlFor="password">Password</label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    className="text-input"
                    placeholder="Create a password"
                    value={form.password}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="input-label" htmlFor="address">Address</label>
                  <textarea
                    id="address"
                    name="address"
                    className="text-input"
                    rows="3"
                    placeholder="Enter your address"
                    value={form.address}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="input-label" htmlFor="phone">Phone Number</label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    className="text-input"
                    placeholder="Enter phone number"
                    value={form.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                {message.text && (
                  <div className={`alert alert-${message.type} py-2`} role="alert">
                    {message.text}
                  </div>
                )}

                <button className="btn-gold submit-btn" type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Creating Account...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-user-plus" /> Create Account
                    </>
                  )}
                </button>
              </form>

              <div className="text-center mt-3">
                <Link to="/" className="text-decoration-none text-muted small">
                  <i className="fas fa-arrow-left me-1" /> Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
